import { Instance, types } from 'mobx-state-tree';

const ChatDraftReplyModel = types.model('ChatDraftReplyModel', {
  maxMessageId: types.string,
  senderName: types.string,
  preview: types.string,
});

const ChatDraftEditModel = types.model('ChatDraftEditModel', {
  maxMessageId: types.string,
  preview: types.string,
});

export const ChatDraftModel = types.model('ChatDraftModel', {
  text: types.optional(types.string, ''),
  reply: types.optional(types.maybeNull(ChatDraftReplyModel), null),
  editing: types.optional(types.maybeNull(ChatDraftEditModel), null),
});

export type TChatDraft = Instance<typeof ChatDraftModel>;
